import * as c from './components';
import { HeadingContext } from './context';



export const Heading = {
    Node: c.Heading,
    Provider: c.HeadingProvider,
    Context: HeadingContext,
};